











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SelectMeetingDropdown_meetings",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SelectMeetingDropdownItem_meeting"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "NewMeeting",
  "abstractKey": "__isNewMeeting"
};

(node ).hash = "cfef9d1e3edb8fe48075623fd191abd5";

export default node;
